import { cn } from "@/shared/ui/cn";
import { BrandMark } from "./BrandMark";

interface BrandProps {
  /** Icon only (the collapsed sidebar rail). */
  compact?: boolean;
  size?: "sm" | "md";
  className?: string;
}

/**
 * The product mark (the accent tile with the A + scan-frame glyphs) plus the "Internal" badge (M5 §6): the two portals share tokens and chrome, so the badge is
 * what keeps an operator from mistaking this for a customer's organisation. One place, so login and shell agree.
 */
export function Brand({ compact = false, size = "sm", className }: BrandProps) {
  return (
    <span className={cn("inline-flex items-center", className)}>
      <span
        aria-hidden={!compact}
        aria-label={compact ? "NexBorg Access Internal" : undefined}
        className={cn(
          "inline-flex items-center justify-center rounded-sm bg-accent text-on-accent",
          size === "sm" ? "size-6" : "size-7",
        )}
      >
        <BrandMark className="w-4/5" />
      </span>
      {!compact ? (
        <>
          <span className="ml-2 truncate text-body font-semibold text-fg">NexBorg Access</span>
          <InternalBadge className="ml-2" />
        </>
      ) : null}
    </span>
  );
}

/** "Internal" in warning tones: unmistakable, and never present in the customer portal. */
export function InternalBadge({ className }: { className?: string | undefined }) {
  return (
    <span
      className={cn(
        "inline-flex h-5 items-center rounded-sm border border-warning/50 bg-warning-soft px-1.5 text-caption font-semibold uppercase tracking-wide text-warning-fg",
        className,
      )}
    >
      Internal
    </span>
  );
}
